import axios from 'axios'
import { Notify } from 'vant'

const service = axios.create({

  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000 // request timeout
})

// 封装请求拦截
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      Notify({ type: 'danger', message: '请检查接口后重试' })
    } else {
      return Promise.resolve(response)
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/config.js